import { useState, useRef, useEffect } from "react";
import "./style.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Grid, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Zoom from "@mui/material/Zoom";
import Fade from "@mui/material/Fade";
import ZoomInIcon from "@mui/icons-material/ZoomIn";

const style = {
  position: "absolute",
  top: "20%",
  left: "33%",
  width: "27rem",
  "@media (min-width: 1636px)": {
    width: "33rem",
  },
  p: 1.5,
};

const VideoModal = (props) => {
  const VdoContainerRef = useRef(null);
  const VdoRef = useRef();
  const classes = useStyles();

  useEffect(() => {
    let temp;
    if (props.visible && props.autoplay) {
      temp = setTimeout(() => {
        VdoRef.current.play();
      }, 1000);
    }

    return () => {
      clearTimeout(temp);
    };
  }, [props.visible]);

  return (
    <>
      {/* <Fade in={true} timeout={500}>
        <img
          src={`${sessionStorage.getItem('media_url')}image/${props.src}`}
          className={props.width ? "" : "imageSize"}
          height={props.height}
          style={{ ...props.style, cursor: "pointer" }}
          onClick={() => {
            setVisible(true);
          }}
        />
      </Fade>
      <IconButton
        aria-label="delete"
        size="medium"
        onClick={() => {
          setVisible(true);
        }}
      >
        <ZoomInIcon fontSize="inherit" />
      </IconButton> */}

      <Modal
        open={props.visible}
        onClose={() => {
          if (!props.persistent) {
            props.toggleModal(false);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
        ref={VdoContainerRef}
      >
        <Zoom in={props.visible}>
          <Box
            sx={{
              ...style,
              backgroundColor: "white",
              border: 0,
              borderRadius: 2,
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              {props.title && (
                <Grid item>
                  <Typography variant="h4">{props.title}</Typography>
                </Grid>
              )}
              <Grid item sx={{ justifyContent: "center" }}>
                <Zoom timeout={500} in={true} mountOnEnter unmountOnExit>
                  <video
                    ref={VdoRef}
                    src={`${sessionStorage.getItem(
                      "media_url"
                    )}static_media/video/phonemes_side/${props.src}`}
                    width="100%"
                    height="100%"
                    style={{ borderRadius: 10, objectFit: "contain" }}
                    controls={true}
                    className={classes.videocls}
                    controlsList="nodownload"
                  ></video>
                </Zoom>
              </Grid>
            </Grid>
          </Box>
        </Zoom>
      </Modal>
    </>
  );
};

const useStyles = makeStyles({
  videocls: {
    width: "26rem",
    borderRadius: 6,
    "@media (min-width: 1636px)": {
      width: "32rem",
    },
  },
});

export default VideoModal;
